import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Details from './components/Details'
import ProfileMenu from '@common/components/ProfileMenu';
import ProductTile from '@pages/ProductListing/view/components/ProductTile';
import { useDispatch } from 'react-redux';
import { fetchWishlist, selectWishlistItems } from 'store/slices/wishlistSlice';
import { useAppSelector } from 'store/hooks';
import Nodata from '@common/components/NoData';


function MyWishlist() {
    const dispatch = useDispatch();
    const productData = [
        {
            id: 1,
            name: "Melange Single Bedsheet set",
            sp: 4500,
            discountPrice: 3500,
            productImgUrl: 'test-product',
            productColorVariants: [
                {
                    id:1,
                    colorCode: '#6C6159',
                },
                {
                    id:2,
                    colorCode: '#F0EBB8',
                },
                {
                    id:3,
                    colorCode: '#ff0000',
                },
                {
                    id:4,
                    colorCode: '#00ff00',
                },
                {
                    id:5,
                    colorCode: '#0000ff',
                }
            ],
            tag: "New Arrival",
        },
        {
            id: 2,
            name: "Melange Single Bedsheet set 2",
            sp: 4500,
            discountPrice: 3500,
            productImgUrl: 'test-product',
            productColorVariants: [
                {
                    id:1,
                    colorCode: '#6C6159',
                },
                {
                    id:2,
                    colorCode: '#F0EBB8',
                },
                {
                    id:3,
                    colorCode: '#ff0000',
                }
            ],
            tag: "sale",
        },
        {
            id: 3,
            name: "Melange Single Bedsheet set 3",
            sp: 4500,
            discountPrice: 3500,
            productImgUrl: 'test-product',
            productColorVariants: [
                {
                    id:1,
                    colorCode: '#6C6159',
                },
                {
                    id:2,
                    colorCode: '#F0EBB8',
                }
            ],
            tag: "",
        },
        {
            id: 4,
            name: "Melange Single Bedsheet set 4",
            sp: 4500,
            discountPrice: 3500,
            productImgUrl: 'test-product',
            productColorVariants: [
                {
                    id:1,
                    colorCode: '#6C6159',
                },
                {
                    id:2,
                    colorCode: '#F0EBB8',
                },
                {
                    id:3,
                    colorCode: '#ff0000',
                },
                {
                    id:4,
                    colorCode: '#0000ff',
                }
            ],
            tag: "",
        },
    
    ]

    useEffect(() => {
        dispatch(fetchWishlist())
    }, [])

    const wishlistItems = useAppSelector(selectWishlistItems)

    // console.log('wishlistItems', wishlistItems);
  return (
    <div className='bs-section'>
        <div className='lyt-profile'>
            <div className='lyt-profile__header'>
                <Link className='lyt-profile__title'>
                    <span className='icon icon-o-left lyt-profile__title-icon'></span>
                    <span className='lyt-profile__title-text'>your profile</span>
                </Link>
            </div>
            <div className='lyt-profile__body'>
                <ProfileMenu data={JSON.parse(localStorage.getItem('u_info')) || {}} />
                <div className='lyt-profile__cont-wrap'>
                    <div className='lyt-wishlist'>
                        <div className='lyt-wishlist__header'>
                            <h2 className='lyt-wishlist__title'>wishlist</h2>
                        </div>
                        <div className='lyt-wishlist__body'>
                            {wishlistItems.length > 0 ? (
                                <ul className='lyt-wishlist__product-grid'>
                                    {wishlistItems?.map((item, index) => {
                                        return(
                                            <li className='lyt-wishlist__product-item' key={index}>
                                                <ProductTile
                                                    productId={item.id}
                                                    productSlug={item.slug}
                                                    imageUrl={item.imageUrl}
                                                    tagTitle={item.badge}
                                                    handleAction={() => {}}
                                                    productTitle={item.name}
                                                    priceValue={item.discount ? item.price - item.discount : null}
                                                    strikePriceValue={item.price}
                                                    colorVariants={item?.colors}
                                                    showAddToCart={true}
                                                    stock={item.stock}
                                                    variant={'wishlist'}
                                                />
                                            </li>
                                        )
                                    })}
                                </ul>
                            ) : (
                                <Nodata visible={true} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MyWishlist